import { getAuthToken, getStoredRoles, persistStoredRoles } from '@/services/authSession';

export const DASHBOARD_AR_ROLES = ['Admin', 'Administrador', 'GestionArtritis'];

const normalizeRoles = (roles) => {
  if (!roles) return [];
  if (Array.isArray(roles)) {
    return roles.map((role) => String(role).trim()).filter(Boolean);
  }
  if (typeof roles === 'string') {
    try {
      const parsed = JSON.parse(roles);
      return normalizeRoles(parsed);
    } catch (error) {
      return roles
        .split(',')
        .map((role) => role.trim())
        .filter(Boolean);
    }
  }
  return [];
};

export const decodeRolesFromToken = (token) => {
  if (!token || typeof token !== 'string') return [];
  const parts = token.split('.');
  if (parts.length < 2) return [];
  try {
    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
    const candidates = [
      payload.roles,
      payload.role,
      payload.Roles,
      payload.Rol,
      payload.rol,
      payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
    ];
    for (const candidate of candidates) {
      const normalized = normalizeRoles(candidate);
      if (normalized.length) return normalized;
    }
  } catch (error) {
    console.warn('No se pudo leer roles del token', error);
  }
  return [];
};

export const extractRolesFromResponse = (responseData) => {
  if (!responseData) return [];
  const candidates = [
    responseData.roles,
    responseData.role,
    responseData.Roles,
    responseData.Role,
    responseData.user?.roles,
    responseData.user?.role,
    responseData.user?.Roles,
    responseData.user?.Role,
  ];
  for (const candidate of candidates) {
    const normalized = normalizeRoles(candidate);
    if (normalized.length) return normalized;
  }
  if (responseData.token) {
    const fromToken = decodeRolesFromToken(responseData.token);
    if (fromToken.length) return fromToken;
  }
  if (responseData.accessToken) {
    const fromAccessToken = decodeRolesFromToken(responseData.accessToken);
    if (fromAccessToken.length) return fromAccessToken;
  }
  return [];
};

export const persistRoles = (roles) => {
  const normalized = normalizeRoles(roles);
  if (normalized.length) {
    persistStoredRoles(normalized);
    return normalized;
  }
  persistStoredRoles([]);
  return [];
};

export const getUserRoles = () => {
  const storedRoles = getStoredRoles();
  if (storedRoles) {
    const normalized = normalizeRoles(storedRoles);
    if (normalized.length) return normalized;
  }
  const tokenRoles = decodeRolesFromToken(getAuthToken());
  if (tokenRoles.length) return tokenRoles;
  return [];
};

export const hasAnyRequiredRole = (requiredRoles = [], userRoles = getUserRoles()) => {
  if (!requiredRoles?.length) return true;
  const normalizedRequired = requiredRoles.map((role) => String(role).toLowerCase());
  return (userRoles || []).some((role) => normalizedRequired.includes(String(role).toLowerCase()));
};
